import { createActions, createReducer } from 'reduxsauce';

// ✅ ACTION TYPES + CREATORS
const { Types, Creators } = createActions(
  {
    // Deals
    getCJDeals: ['params'],
    getCJDealsRequest: [],
    getCJDealsSuccess: ['deals'],
    getCJDealsFailure: ['error'],

    // Advertisers
    getCJAdvertisers: [],
    getCJAdvertisersRequest: [],
    getCJAdvertisersSuccess: ['advertisers'],
    getCJAdvertisersFailure: ['error'],

    // Product Images
    getCJProductImages: ['params'],
    getCJProductImagesRequest: [],
    getCJProductImagesSuccess: ['productImages'],
    getCJProductImagesFailure: ['error'],

    // Sale Products (Product Feed API)
    getCJSaleProducts: ['params'],
    getCJSaleProductsRequest: [],
    getCJSaleProductsSuccess: ['saleProducts'],
    getCJSaleProductsFailure: ['error'],
  },
  { prefix: 'cb/cj/' }
);

// ✅ INITIAL STATE
export const INITIAL_STATE = {
  deals: [],
  advertisers: [],
  productImages: [],
  saleProducts: [],
  loading: {
    deals: false,
    advertisers: false,
    productImages: false,
    saleProducts: false,
  },
  error: {
    deals: null,
    advertisers: null,
    productImages: null,
    saleProducts: null,
  },
};

// ✅ REDUCER HANDLERS
export const HANDLERS = {
  // DEALS
  [Types.GET_CJ_DEALS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, deals: true },
    error: { ...state.error, deals: null },
  }),
  [Types.GET_CJ_DEALS_SUCCESS]: (state, { deals }) => ({
    ...state,
    loading: { ...state.loading, deals: false },
    deals,
  }),
  [Types.GET_CJ_DEALS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, deals: false },
    error: { ...state.error, deals: error },
  }),

  // ADVERTISERS
  [Types.GET_CJ_ADVERTISERS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, advertisers: true },
    error: { ...state.error, advertisers: null },
  }),
  [Types.GET_CJ_ADVERTISERS_SUCCESS]: (state, { advertisers }) => ({
    ...state,
    loading: { ...state.loading, advertisers: false },
    advertisers,
  }),
  [Types.GET_CJ_ADVERTISERS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, advertisers: false },
    error: { ...state.error, advertisers: error },
  }),

  // PRODUCT IMAGES
  [Types.GET_CJ_PRODUCT_IMAGES_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, productImages: true },
    error: { ...state.error, productImages: null },
  }),
  [Types.GET_CJ_PRODUCT_IMAGES_SUCCESS]: (state, { productImages }) => ({
    ...state,
    loading: { ...state.loading, productImages: false },
    productImages,
  }),
  [Types.GET_CJ_PRODUCT_IMAGES_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, productImages: false },
    error: { ...state.error, productImages: error },
  }),

  // SALE PRODUCTS
  [Types.GET_CJ_SALE_PRODUCTS_REQUEST]: (state) => ({
    ...state,
    loading: { ...state.loading, saleProducts: true },
    error: { ...state.error, saleProducts: null },
    saleProducts: [],
  }),
  [Types.GET_CJ_SALE_PRODUCTS_SUCCESS]: (state, { saleProducts }) => ({
    ...state,
    loading: { ...state.loading, saleProducts: false },
    saleProducts,
  }),
  [Types.GET_CJ_SALE_PRODUCTS_FAILURE]: (state, { error }) => ({
    ...state,
    loading: { ...state.loading, saleProducts: false },
    error: { ...state.error, saleProducts: error },
  }),
};

// ✅ EXPORT
export { Types as types, Creators as actions };
export default createReducer(INITIAL_STATE, HANDLERS);